/* eslint-disable @typescript-eslint/no-explicit-any */
export enum Lang {
  EN, // english
  JP, // japanese
}

export enum Page {
  ORG,
  ORG_MAPPING,
  ORG_TRANSLATION,
  LOCATION,
  XSSI_CONNECTION,
  OTAR_CONNECTION,
  CANNED_MESSAGE,
  LMR_USER,
  LMR_GROUP,
  MCPTT_USER,
  MCPTT_GROUP,
  DFSI_CONNECTION,
  DFSI_CHANNEL,
  DFSI_GROUP,
  FIXED_NETWORK_ELEMENT,
  ACTIVE_ALARM,
  FAULTS,
  INVENTORY,
  INSTANCE,
  HISTORICAL_ALARM,
  P25_UNIT,
  PUBLISH_INFO,
  P25_GROUP,
  P25_AFFILIATIONS,
  OVERVIEW,
  IKI_CONNECTION,
}

export enum Operation {
  READ,
  CREATE,
  EDIT,
  DELETE,
}

export enum GeneralTranslationCategory {
  TABLE_HEADERS,
  PERMISSION_DENIED_HEADER,
  PERMISSION_DENIED_SUBTEXT,
  ADVANCED_SEARCH,
  ADD_FORM_FIELDS,
  EDIT_FORM_FIELDS,
  EDIT_ROW,
  EDIT_ORG_PROFILE,
  EDIT_GROUP,
  LOADING_TEXT,
  SIDEPANEL_GENERAL,
  CREATE_NEW_BTN_LABEL,
  FORM_VALIDATION,
  VIEW_FORM_FIELDS,
  FILTER_COLUMNS,
  TABLE_SEARCH,
  TOGGLE,
  BREADCRUMBS,
  MISC,
  HEX_INPUT,
  TAB_LIST,
  TILE_LIST,
  OVERVIEW_TILE,
  AUTH,
  DATA_TABLE_GENERAL,
  MENU_TEXT,
  BULK_UPLOAD,
}

export interface IPageTranslation {
  // first
  [Page.ORG]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      cancelModal: {
        header: string;
        modalContent: string;
      };
      buttonLabels: {
        goBack: string;
        cancel: string;
        create: string;
      };
      sucessMsg: string;
    };
    [Operation.EDIT]: Record<string, any>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  // first
  [Page.ORG_MAPPING]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      deleteModal: {
        header: string;
        description: (val: string | null) => string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      buttonLabels: {
        create: string;
        cancel: string;
      };
      sucessMessage: string;
      errorMessage: string;
      draftAbortModal: {
        header: string;
        description: string;
        confirmButtonLabel: string;
      };
    };
    [Operation.EDIT]: Record<string, any>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.ORG_TRANSLATION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      translationDropdown: {
        titleText: string;
        label: string;
      };
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      dropdown: {
        label: string;
        dropdownItems: {
          "floor-control": string;
          "P25-TO-MC-FC-PRI": string;
          "MC-TO-P25-FC-PRI": string;
          "DMR-TO-MC-FC-PRI": string;
          "MC-TO-DMR-FC-PRI": string;
        };
      };
      translationDropdownText: string;
      successMsg: string;
      errorMsg: string;
      btnLabels: {
        cancelConfirmationLabel: string;
        cancel: string;
        create: string;
      };
      cancelModal: {
        header: string;
        description: string;
      };
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  // first
  [Page.LOCATION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: Record<string, any>;
    [Operation.EDIT]: Record<string, any>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.XSSI_CONNECTION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        description: (val: string | null) => string;
      };
    };
    [Operation.CREATE]: {
      successAlertMessage: string;
      header: string;
      headerSubtext: string;
      reuseXSSIConnection: {
        reuseToggleLabel: string;
        reuseToggleTooltip: string;
        reuseableXSSIConnectionLabel: string;
        reuseableXSSIConnectionTooltip: string;
        noMatchFound: string;
      };
      infoAlert: {
        heading: string;
        subText: string;
      };
      labels: {
        finishButton: string;
        nextButton: string;
        previousButton: string;
        proceedToRangesButon: string;
        backToListing: string;
      };
      tabList: string[];
      addConnection: {
        successAlertMessage: string;
        deleteModal: {
          header: string;
          description: string;
          goBackButtonLabel: string;
        };
        btnLabels: {
          cancel: string;
          createConnection: string;
        };
      };
      ranges: {
        createNewUnitRangeText: string;
        createNewIWFUnitText: string;
        createNewIWFRangeText: string;
        createNewRadioRangeText: string;
        addToRange: string;
        deleteModal: {
          title: string;
          description: string;
          cancel: string;
          delete: string;
        };
      };
    };

    [Operation.EDIT]: {
      successAlertMessage: string;
      connection: {
        heading: string;
        labels: {
          updateConnection: string;
        };
      };
      range: {
        successAlertMessage: string;
        deleteSuccessAlertMessage: string;
        editSuccessAlertMessage: string;
        infoAlert: {
          subText: string;
          heading: (groupName: string) => string;
        };
        unitRangeInfoAlert: {
          subText: string;
          heading: string;
        };
        heading: {
          iwfGroup: string;
          radioGroup: string;
          unit: string;
          iwfUnit: string;
        };
        ranges: string;
        unitRanges: string;
        labels: {
          creationDate: string;
          modificationDate: string;
          cancelButton: string;
          saveButton: string;
          editButton: string;
          deleteButton: string;
          discardButton: string;
          id: string;
          groupLabelPrefix: string;
          unitLabelPrefix: string;
          iwfUnitLabelPrefix: string;
          maxId: (label: string) => string;
          minId: (label: string) => string;
          maxInvalidText: (label: string, min?: number, max?: number) => string;
          minInvalidText: (label: string, min?: number, max?: number) => string;
          maxToolTipText: (label: string, min?: number, max?: number) => string;
          minToolTipText: (label: string, min?: number, max?: number) => string;
        };
      };
      tabList: string[];
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.OTAR_CONNECTION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.CANNED_MESSAGE]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.LMR_USER]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.LMR_GROUP]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: {
      lmrGroup: {
        successAlertMessage: string;
      };
      lmrGroupProfile: {
        successAlertMessage: string;
      };
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.MCPTT_USER]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.MCPTT_GROUP]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: {
      mcGroup: {
        successAlertMessage: string;
      };
      mcGroupProfile: {
        successAlertMessage: string;
      };
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.DFSI_CONNECTION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
      infoAlertHeading: {
        dataSearched: string;
        dataNotSearched: string;
      };
      infoAlertSubText: {
        dataSearched: string;
        dataNotSearched: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: {
      deleteModal: {
        header: (header: string) => string;
        description: (header: string, data: string) => string;
      };
      cancelModal: {
        header: (header: string) => string;
        description: string;
      };
      btnLabel: {
        edit: string;
        delete: string;
        cancel: string;
        save: string;
      };
      successAlertMessage: string;
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.DFSI_CHANNEL]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
      infoAlertHeading: {
        dfsiConnectionExists: string;
        channelsData: string;
      };
      infoAlertSubText: {
        dfsiConnectionExists: string;
        channelsData: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: {
      deleteModal: {
        header: (header: string) => string;
        description: (header: string, data: string) => string;
      };
      cancelModal: {
        header: (header: string) => string;
        description: string;
      };
      btnLabel: {
        edit: string;
        delete: string;
        cancel: string;
        save: string;
      };
      successAlertMessage: string;
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.DFSI_GROUP]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
      infoAlertHeading: {
        dfsiChannelIDExists: string;
        groupData: string;
      };
      infoAlertSubText: {
        dfsiChannelIDExists: string;
        groupData: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        missingOrg: {
          heading: string;
          subText: string;
        };
        missingIWF: {
          heading: string;
          subText: string;
        };
        missingIWFBulk: {
          heading: string;
          subText: string;
        };
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: {
      successMsg: string;
      btnLabel: {
        edit: string;
        delete: string;
        cancel: string;
        save: string;
      };
      cancelModal: {
        header: (header: string) => string;
        description: string;
      };
      deleteModal: {
        header: (header: string) => string;
        description: (header: string, data: string) => string;
      };
    };
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.IKI_CONNECTION]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      deleteModal: {
        header: string;
        description: string;
        goBackButtonLabel: string;
      };
      cancelButtonLabel: string;
      createButtonLabel: string;
      successAlertMessage: string;
    };
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.P25_UNIT]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      viewRow: {
        panelName: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.FIXED_NETWORK_ELEMENT]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
      infoAlert: {
        heading: string;
        subText: string;
      };
    };
    [Operation.CREATE]: Record<string, any>;
    [Operation.EDIT]: Record<string, any>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.P25_AFFILIATIONS]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
      infoAlert: {
        heading: string;
        subText: string;
      };
    };
    [Operation.CREATE]: Record<string, any>;
    [Operation.EDIT]: Record<string, any>;
    [Operation.DELETE]: {
      successAlertMessage: string;
    };
  };
  [Page.ACTIVE_ALARM]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
      successAlertMessage: string;
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.FAULTS]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.INVENTORY]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.INSTANCE]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      viewRow: {
        panelName: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.HISTORICAL_ALARM]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.PUBLISH_INFO]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      editRow: {
        panelName: string;
        header: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.P25_GROUP]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      infoAlert: {
        heading: string;
        subText: string;
      };
      viewRow: {
        panelName: string;
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
  [Page.OVERVIEW]: {
    [Operation.READ]: {
      header: string;
      headerSubtext: string;
      allOrgText: string;
      config: {
        infoAlert: {
          heading: string;
          subText: string;
        };
      };
      realtime: {
        infoAlert: {
          heading: string;
          subText: string;
        };
      };
      chartModal: {
        getChartModalHeaderText: (
          selectedTab: string,
          ConfigTileList: string[],
          RealTimeTileList: string[],
          index: any
        ) => string;
        getChartModalSubHeaderText: (
          selectedTab: string,
          ConfigTileList: string[],
          RealTimeTileList: string[],
          index: any
        ) => string;
      };
      lineChart: {
        XaxisLabels: {
          min: string;
          max: string;
          avg: string;
        };
      };
    };
    [Operation.CREATE]: Record<string, never>;
    [Operation.EDIT]: Record<string, never>;
    [Operation.DELETE]: Record<string, never>;
  };
}

interface ADD_FORM_FIELDS {
  label: string;
  tooltipText: string;
}

export interface IGeneralTranslation {
  [GeneralTranslationCategory.TABLE_HEADERS]: {
    [Page.ORG]: {
      "ORG-ID": string;
      "ORG-NAME": string;
      action: string;
    };
    [Page.ORG_MAPPING]: {
      "ORG-ID": string;
      "IWF-ID": string;
      action: string;
    };
    [Page.ORG_TRANSLATION]: {
      ID: string;
      EFI: string;
      EFO: string;
      FROM: string;
      TO: string;
      action: string;
    };
    [Page.LOCATION]: {
      "IWF-ID": string;
      "IWF-LOCATION-NAME": string;
      "IWF-DOMAIN-NAME": string;
      action: string;
    };
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": string;
      "RADIO-IPV4-ADDR": string;
      "RADIO-RFSS-ID": string;
      "RADIO-SYSTEM-ID": string;
      "RADIO-WACN-ID": string;
      action: string;
    };
    [Page.OTAR_CONNECTION]: {
      "CONNECTION-ID": string;
      "KMF-RADIO-SET-IDENTIFIER": string;
      "KMF-PORT": string;
      "KMF-IPV4-ADDR": string;
      action: string;
    };
    [Page.CANNED_MESSAGE]: {
      "MSG-ID": string;
      "CANNED-TEXT": string;
      action: string;
    };
    [Page.LMR_USER]: {
      "LMR-ID": string;
      "LMR-NW-TYPE": string;
      "MAPPED-MCPTT-ID": string;
      action: string;
    };
    [Page.LMR_GROUP]: {
      "TG-ID": string;
      "MAPPED-MCPTT-GID": string;
      "LMR-NW-TYPE": string;
      action: string;
    };
    [Page.MCPTT_USER]: {
      "MCPTT-ID": string;
      "DISPLAY-NAME": string;
      action: string;
    };
    [Page.MCPTT_GROUP]: {
      "MCPTT-GID": string;
      "MAPPED-P25-TG-ID": string;
      action: string;
    };
    [Page.DFSI_CONNECTION]: {
      "CONNECTION-ID": string;
      "DFSI-VERSION": string;
      "HOST-CONTROL-IPV4-ADDR": string;
      "HOST-VOICE-IPV4-ADDR": string;
      "FIXED-STATION-CONTROL-IPV4-ADDR": string;
      action: string;
    };
    [Page.DFSI_CHANNEL]: {
      "CONNECTION-ID": string;
      "CHANNEL-ID": string;
      "CHANNEL-MODE": string;
      "OUTBOUND-NETWORK-ACCESS-CODE": string;
      "INBOUND-NETWORK-ACCESS-CODE": string;
      action: string;
    };
    [Page.DFSI_GROUP]: {
      "DFSI-LOGICAL-GID": string;
      "DFSI-GROUP-NAME": string;
      action: string;
    };
    [Page.IKI_CONNECTION]: {
      "CONNECTION-ID": string;
      "IKI-NAME": string;
      "IKI-PORT": string;
      "IKI-IPV4-ADDR": string;
      action: string;
    };
    [Page.FIXED_NETWORK_ELEMENT]: {
      "TARGET-ID": string;
      PERIOD: string;
      RFSS: string;
      MONITOR: string;
      action: string;
    };
    [Page.ACTIVE_ALARM]: {
      "NOTIFICATION-ID": string;
      "EVENT-ID": string;
      HOSTNAME: string;
      CreatedAt: string;
      action: string;
    };
    [Page.FAULTS]: {
      "EVENT-ID": string;
      HOSTNAME: string;
      CreatedAt: string;
      INSTANCE: string;
      VERSION: string;
      action: string;
    };
    [Page.INVENTORY]: {
      "EVENT-ID": string;
      "EVENT-NAME": string;
      "EVENT-PERCEIVED-SEVERITY": string;
      "EVENT-SYMPTOMS": string;
      "SOURCE-COMPONENT": string;
      state: string;
      action: string;
    };
    [Page.INSTANCE]: {
      "ENGINE-ID": string;
      HOSTNAME: string;
      INSTANCE: string;
      "STARTED-AT": string;
      action: string;
    };
    [Page.HISTORICAL_ALARM]: {
      "EVENT-ID": string;
      HOSTNAME: string;
      "ROW-TYPE": string;
      CreatedAt: string;
      action: string;
    };
    [Page.P25_UNIT]: {
      "TARGET-ID": string;
      PERIOD: string;
      MONITOR: string;
      RFSS: string;
      action: string;
    };
    [Page.PUBLISH_INFO]: {
      "GROUP-ID": string;
      "USER-ID": string;
      "SECS-TO-EXPIRE": string;
    };
    [Page.P25_GROUP]: {
      "TARGET-ID": string;
      PERIOD: string;
      RFSS: string;
      MONITOR: string;
      action: string;
    };
    [Page.P25_AFFILIATIONS]: {
      "TARGET-ID": string;
      PERIOD: string;
      RFSS: string;
      MONITOR: string;
      action: string;
    };
  };
  [GeneralTranslationCategory.TABLE_SEARCH]: {
    label: string;
    placeholder: string;
    closeButtonLabelText: string;
  };
  [GeneralTranslationCategory.PERMISSION_DENIED_HEADER]: string;
  [GeneralTranslationCategory.PERMISSION_DENIED_SUBTEXT]: (
    op: string,
    module: string
  ) => string;
  [GeneralTranslationCategory.ADVANCED_SEARCH]: {
    label: string;
    cancelButtonLabel: string;
    applyButtonLabel: string;
  };
  [GeneralTranslationCategory.LOADING_TEXT]: {
    defaultLoadingText: string;
    groupLoadingText: string;
    groupProfileLoadingText: string;
    orgProfileLoadingText: string;
    orgLoadingText: string;
  };
  [GeneralTranslationCategory.CREATE_NEW_BTN_LABEL]: string;
  [GeneralTranslationCategory.SIDEPANEL_GENERAL]: {
    buttonLabels: {
      edit: string;
      save: string;
      cancel: string;
      delete: string;
    };
    nonEditableFields: {
      CreationDate: string;
      ModificationDate: string;
      "CONNECTION-ID": string;
      "MCPTT-ID": string;
      "DFSI-VERSION": string;
      "LMR-ID": string;
      "MSG-ID": string;
      "TG-ID": string;
      "MCPTT-GID": string;
      "ORG-ID": string;
      "Reference ID": string;
      "Translation Type": string;
      "Channel ID": string;
      "DFSI-GROUP-NAME": string;
      "DFSI-LOGICAL-GID": string;
      "IWF-ID": string;
      "DFSI-UNIT-CONTROL-ATTEMPT-LIMIT": string;
      "DFSI-UNIT-CONTROL-RETRY-TIME": string;
      "IWF-ROLE": string;
    };
    alarmsTabs: {
      comments: string;
      additionalInfo: string;
      commentField: {
        buttonLabel: string;
        placeholder: string;
      };
    };
    deleteModal: {
      header: string;
    };
  };
  [GeneralTranslationCategory.EDIT_ROW]: {
    CANCEL_MODAL: {
      header: string;
      description: string;
      confirmationButtonLabel: string;
    };
    DELETE_MODAL: {
      header: string;
      description: (header: string, data: string) => string;
      buttonLabels: {
        keepIt: string;
        delete: string;
      };
    };
    EDIT_SUCCESS_MESSAGE: string;
  };
  [GeneralTranslationCategory.ADD_FORM_FIELDS]: {
    [Page.ORG]: {
      "Organisation ID": ADD_FORM_FIELDS;
      "Organisation Name": ADD_FORM_FIELDS;
    };
    [Page.ORG_MAPPING]: Record<string, any>;
    [Page.ORG_TRANSLATION]: Record<string, any>;
    [Page.LOCATION]: Record<string, any>;
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": ADD_FORM_FIELDS;
      "RADIO-IPV4-ADDR": ADD_FORM_FIELDS;
      "RADIO-RFSS-ID": ADD_FORM_FIELDS;
      "RADIO-SYSTEM-ID": ADD_FORM_FIELDS;
      "RADIO-WACN-ID": ADD_FORM_FIELDS;
      "RADIO-RFSS-4-HEX-DIGIT": ADD_FORM_FIELDS;
      "IWF-RFSS-ID": ADD_FORM_FIELDS;
      "IWF-SYSTEM-ID": ADD_FORM_FIELDS;
      "IWF-WACN-ID": ADD_FORM_FIELDS;
      "POLLING-ENABLED": ADD_FORM_FIELDS;
      "POLLING-INTERVAL-CONNECTED": ADD_FORM_FIELDS;
      "POLLING-INTERVAL-DISCONNECTED": ADD_FORM_FIELDS;
      "RESPONSES-BEFORE-CONNECTED": ADD_FORM_FIELDS;
      "MISSED-RESPONSES-BEFORE-DISCONNECTED": ADD_FORM_FIELDS;
      "VOCODER-MODES": ADD_FORM_FIELDS;
      "REUSE-EXISTING-CONNECTION": ADD_FORM_FIELDS;
      "SELECTED-ORGANISATION": ADD_FORM_FIELDS;
      "REUSED-CONNECTION": ADD_FORM_FIELDS;
    };
    [Page.OTAR_CONNECTION]: Record<string, any>;
    [Page.CANNED_MESSAGE]: Record<string, any>;
    [Page.LMR_USER]: Record<string, any>;
    [Page.LMR_GROUP]: Record<string, any>;
    [Page.MCPTT_USER]: Record<string, any>;
    [Page.MCPTT_GROUP]: Record<string, any>;
    [Page.DFSI_CONNECTION]: Record<string, any>;
    [Page.DFSI_CHANNEL]: Record<string, any>;
    [Page.DFSI_GROUP]: Record<string, any>;
    [Page.IKI_CONNECTION]: Record<string, any>;
    [Page.ACTIVE_ALARM]: Record<string, any>;
    [Page.FAULTS]: Record<string, any>;
    [Page.INVENTORY]: Record<string, any>;
    [Page.INSTANCE]: Record<string, any>;
    [Page.HISTORICAL_ALARM]: Record<string, any>;
    [Page.PUBLISH_INFO]: Record<string, any>;
  };
  [GeneralTranslationCategory.EDIT_FORM_FIELDS]: {
    [Page.ORG]: Record<string, any>;
    [Page.ORG_MAPPING]: Record<string, any>;
    [Page.ORG_TRANSLATION]: Record<string, any>;
    [Page.LOCATION]: Record<string, any>;
    [Page.XSSI_CONNECTION]: Record<string, any>;
    [Page.OTAR_CONNECTION]: Record<string, any>;
    [Page.CANNED_MESSAGE]: Record<string, any>;
    [Page.LMR_USER]: Record<string, any>;
    [Page.LMR_GROUP]: Record<string, any>;
    [Page.MCPTT_USER]: Record<string, any>;
    [Page.MCPTT_GROUP]: Record<string, any>;
    [Page.DFSI_CONNECTION]: Record<string, any>;
    [Page.DFSI_CHANNEL]: Record<string, any>;
    [Page.DFSI_GROUP]: Record<string, any>;
    [Page.IKI_CONNECTION]: Record<string, any>;
    [Page.ACTIVE_ALARM]: Record<string, any>;
    [Page.FAULTS]: Record<string, any>;
    [Page.INVENTORY]: Record<string, any>;
    [Page.INSTANCE]: Record<string, any>;
    [Page.HISTORICAL_ALARM]: Record<string, any>;
    [Page.PUBLISH_INFO]: Record<string, any>;
  };
  [GeneralTranslationCategory.VIEW_FORM_FIELDS]: {
    [Page.ORG]: Record<string, any>;
    [Page.ORG_MAPPING]: Record<string, any>;
    [Page.ORG_TRANSLATION]: Record<string, any>;
    [Page.LOCATION]: Record<string, any>;
    [Page.XSSI_CONNECTION]: Record<string, any>;
    [Page.OTAR_CONNECTION]: Record<string, any>;
    [Page.CANNED_MESSAGE]: Record<string, any>;
    [Page.LMR_USER]: Record<string, any>;
    [Page.LMR_GROUP]: Record<string, any>;
    [Page.MCPTT_USER]: Record<string, any>;
    [Page.MCPTT_GROUP]: Record<string, any>;
    [Page.DFSI_CONNECTION]: Record<string, any>;
    [Page.DFSI_CHANNEL]: Record<string, any>;
    [Page.DFSI_GROUP]: Record<string, any>;
    [Page.FIXED_NETWORK_ELEMENT]: Record<string, any>;
    [Page.ACTIVE_ALARM]: Record<string, any>;
    [Page.FAULTS]: Record<string, any>;
    [Page.INVENTORY]: Record<string, any>;
    [Page.INSTANCE]: Record<string, any>;
    [Page.HISTORICAL_ALARM]: Record<string, any>;
    [Page.PUBLISH_INFO]: Record<string, any>;
    [Page.P25_UNIT]: Record<string, any>;
    [Page.P25_GROUP]: Record<string, any>;
    [Page.P25_AFFILIATIONS]: Record<string, any>;
  };
  [GeneralTranslationCategory.FORM_VALIDATION]: {
    required: (text: string) => string;
    range: string;
    lessThan: string;
    characterValidation: (text: string) => string;
    IPV4Validation: (text: string) => string;
    VocoderValidation: (text: string) => string;
    newtworkAccessCodeValidation: (
      text: string,
      range: string,
      invalidValue1: string,
      invalidValue2: string
    ) => string;
    reservedIdentifier: ({
      fieldName,
      reservedWord,
    }: {
      fieldName: string;
      reservedWord: string;
    }) => string;
  };
  [GeneralTranslationCategory.BREADCRUMBS]: {
    configurationmanagement: string;
    cannedmessages: string;
    lmrgroups: string;
    lmrusers: string;
    mcpttgroups: string;
    dfsiconnections: string;
    dfsichannels: string;
    dfsigroups: string;
    mcpttusers: string;
    locations: string;
    organizationmapping: string;
    organizations: string;
    organizationtranslation: string;
    otarconnections: string;
    xssiconnections: string;
    ikiconnections: string;
    new: string;
    bulk: string;
    faultmanagement: string;
    activealarms: string;
    faults: string;
    inventory: string;
    instances: string;
    historicalalarms: string;
    realtime: string;
    publishinfo: string;
    p25unit: string;
    p25group: string;
    fixednetworkelement: string;
    p25groupaffiliations: string;
    overview: string;
    default: string;
  };
  [GeneralTranslationCategory.TOGGLE]: {
    labelA: string;
    labelB: string;
    "un-suppress": string;
    suppress: string;
  };
  [GeneralTranslationCategory.HEX_INPUT]: {
    HEX: string;
    DEC: string;
    dropdownLabel: string;
  };
  [GeneralTranslationCategory.MISC]: {
    ORG_DROPDOWN: {
      label: string;
      placeholder: string;
    };
  };
  [GeneralTranslationCategory.EDIT_GROUP]: {
    panelName: string;
    cancelModal: {
      header: (header: string) => string;
      description: string;
    };
    cancelProfileModal: {
      header: (header: string) => string;
      description: string;
    };
    deleteModal: {
      header: (header: string) => string;
      description: (header: string, data: string) => string;
    };
  };
  [GeneralTranslationCategory.EDIT_ORG_PROFILE]: {
    profilePanelName: string;
    cancelOrgModal: {
      header: (header: string) => string;
      description: string;
    };
    cancelOrgProfileModal: {
      header: (header: string) => string;
      description: string;
    };
    deleteOrgModal: {
      header: (header: string) => string;
      description: (header: string, data: string) => string;
    };
    orgProfileSucessMsg: string;
  };
  [GeneralTranslationCategory.FILTER_COLUMNS]: {
    [Page.XSSI_CONNECTION]: {
      "CONNECTION-ID": string;
      "RADIO-IPV4-ADDR": string;
      "RADIO-RFSS-ID": string;
      "RADIO-SYSTEM-ID": string;
      "RADIO-WACN-ID": string;
    };
    [Page.P25_GROUP]: {
      RFSS: string;
      "TARGET-ID": string;
    };
    [Page.FIXED_NETWORK_ELEMENT]: {
      RFSS: string;
      "TARGET-ID": string;
    };
    [Page.LMR_GROUP]: {
      "TG-ID": string;
      "MAPPED-MCPTT-GID": string;
      "LMR-NW-TYPE": string;
    };
    [Page.DFSI_CONNECTION]: {
      "CONNECTION-ID": string;
    };
    [Page.LMR_USER]: {
      "LMR-ID": string;
      "LMR-NW-TYPE": string;
      "MAPPED-MCPTT-ID": string;
      "DISPLAY-NAME": string;
      "MUTUAL-AID": string;
    };
    [Page.MCPTT_GROUP]: {
      "MCPTT-GID": string;
      "MAPPED-P25-TG-ID": string;
      "MAPPED-DMR-TG-ID": string;
      "MAPPED-ROIP-TG-ID": string;
      "MAPPED-DFSI-TG-ID": string;
    };
    [Page.MCPTT_USER]: {
      "MCPTT-ID": string;
      "MAPPED-P25-ID": string;
      "MAPPED-DMR-ID": string;
      "MAPPED-ROIP-ID": string;
      "MAPPED-DFSI-ID": string;
      "DISPLAY-NAME": string;
      "MUTUAL-AID": string;
    };
    [Page.OTAR_CONNECTION]: {
      "CONNECTION-ID": string;
      "KMF-RADIO-SET-IDENTIFIER": string;
    };
    [Page.CANNED_MESSAGE]: {
      "MSG-ID": string;
      "CANNED-TEXT": string;
    };
    [Page.ORG]: {
      "Organisation ID": string;
      "Organisation Name": string;
    };
    [Page.ORG_TRANSLATION]: {
      ID: string;
      EFI: string;
      EFO: string;
      FROM: string;
      TO: string;
    };
    [Page.ORG_MAPPING]: {
      "IWF-ID": string;
      "ORG-ID": string;
    };
    [Page.LOCATION]: {
      "IWF ID": string;
      "IWF Location Name": string;
      "IWF Domain Name": string;
    };
    [Page.IKI_CONNECTION]: {
      "CONNECTION-ID": string;
      "IKI-IPV4-ADDR": string;
      "IKI-PORT": string;
      "IKI-NAME": string;
    };
    [Page.PUBLISH_INFO]: {
      "GROUP-ID": string;
      "USER-ID": string;
    };
    [Page.P25_UNIT]: {
      RFSS: string;
      "TARGET-ID": string;
    };
    [Page.P25_AFFILIATIONS]: {
      RFSS: string;
      "TARGET-ID": string;
    };
  };
  [GeneralTranslationCategory.TAB_LIST]: {
    ConfigurationManagement: string;
    RealTimeManagement: string;
  };
  [GeneralTranslationCategory.TILE_LIST]: {
    ConfigurationManagement: {
      LMRUsers: string;
      LMRGroups: string;
      LMRMessages: string;
      MCGroups: string;
      MCUsers: string;
      DFSIGroups: string;
      DFSIChannels: string;
      DFSIConnections: string;
      XSSIConnections: string;
      OTARConnections: string;
    };
    RealTimeManagement: {
      PublishInfo: string;
      P25Unit: string;
      P25Group: string;
      FixedNetwork: string;
      Affiliation: string;
    };
    OrgTileList: {
      Organisations: string;
      Mappings: string;
      Locations: string;
    };
  };
  [GeneralTranslationCategory.OVERVIEW_TILE]: {
    labels: {
      total: string;
      min: string;
      max: string;
      avg: string;
    };
    btnLabel: string;
  };
  [GeneralTranslationCategory.AUTH]: {
    header: string;
    description: string;
    authFields: {
      label: {
        username: string;
        password: string;
      };
      placeholder: {
        username: string;
        password: string;
      };
    };
    btnLabels: {
      submit: string;
      logOut: string;
    };
  };
  [GeneralTranslationCategory.DATA_TABLE_GENERAL]: {
    noDataForSelectedOrg: {
      infoAlert: {
        heading: string;
        subText: string;
      };
    };
  };
  [GeneralTranslationCategory.MENU_TEXT]: {
    OverviewMenuItems: {
      parentItem: string;
      childrenItems: Record<string, string>;
    };
    ConfigurationManagementMenuItems: {
      parentItem: string;
      childrenItems: {
        Organisations: string;
        OrgMappings: string;
        OrgTranslations: string;
        Locations: string;
        LMRUsers: string;
        LMRGroups: string;
        CannedMsgs: string;
        MCGroups: string;
        MCUsers: string;
        DFSIGroups: string;
        DFSIChannels: string;
        DFSIConnections: string;
        XSSIConnections: string;
        OTARConnections: string;
        IKIConnections: string;
      };
    };
    FaultManagementMenuItems: {
      parentItem: string;
      childrenItems: {
        ActiveAlarms: string;
        Faults: string;
        Inventory: string;
        Instances: string;
        HistoricalAlarms: string;
      };
    };
    RealTimeManagementMenuItems: {
      parentItem: string;
      childrenItems: {
        PublishInfo: string;
        P25Unit: string;
        P25Group: string;
        FixedNetwork: string;
        Affiliation: string;
      };
    };
  };
  [GeneralTranslationCategory.BULK_UPLOAD]: {
    TabList: {
      tabName: {
        import: string;
        upload: string;
        report: string;
      };
    };
    handleBulkUploadPageHeaderText: (moduleName: string) => string;
    DragnDropLabelText: string;
    InvalidFileTypeText: string;
    InvalidCertificateTypeText: string;
    ColumnMismatchText: string;
    MaxRowLimitText: string;
    BulkUploadModal: {
      header: string;
      descriptionText: string;
      handleProgressHelperText: (
        count: number,
        maxRowCount: number,
        moduleName: string
      ) => string;
      waitingHelperText: string;
      doneHelperText: string;
    };
    Notes: {
      title: string;
      point1: string;
      point2: string;
      dfsiChannelNote1: string;
      hexValueNote: string;
    };
    ImportTab: {
      title: string;
      downloadTemplateInstructionText: string;
      downloadTemplateLinkText: string;
      handleFileUpoadtext: (filename: string) => string;
      uploadButtonLabel: string;
    };
    ErrorTab: {
      title: string;
      readOnlyData: {
        fileLabel: string;
        timestampLabel: string;
        totalRowsLabel: string;
        handleTotalConnectionsCreatedLabel: (moduleName: string) => string;
        errorLabel: string;
        downloadErrorReportInstructionText: string;
        downloadErrorLinkText: string;
        errorMessage: string;
      };
    };
    InfoAlert: {
      header: string;
      subHeader: string;
    };
    RowInfoAlert: {
      header: string;
      subHeader: string;
    };
    ColumnInfoAlert: {
      header: string;
      subHeader: string;
    };
    ProgressBar: {
      finshedLabelText: string;
      dataProcessingLabelText: string;
    };
  };
}
